import React from "react";

/** Wraps content in a Bootstrap container. Supports fluid prop. */
const Container = ({ fluid = false, className = "", style, children, ...rest }) => {
  const cls = [fluid ? "container-fluid" : "container", className].filter(Boolean).join(" ");
  return (
    <div className={cls} style={style} {...rest}>
      {children}
    </div>
  );
};

export default Container;
